import React, { Children } from 'react';
import { motion } from 'framer-motion';
export function PainPoints() {
  const points = [{
    title: 'Urgencias 24/7 con calma',
    description: 'Sabemos que cada segundo cuenta. Nuestro equipo está preparado las 24 horas para actuar con precisión y serenidad.'
  }, {
    title: 'Cirugías de alta complejidad',
    description: 'Tecnología de última generación y manos expertas para los procedimientos más delicados.'
  }, {
    title: 'Diagnóstico preventivo digital',
    description: 'Anticipamos problemas antes de que aparezcan con estudios avanzados y seguimiento personalizado.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  return <section className="py-24 md:py-32 bg-cream" data-id="element-86">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mb-20" data-id="element-88">
          <h2 className="text-4xl md:text-5xl text-matte" data-id="element-89">
            Tu tranquilidad, su salud
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8" data-id="element-90">
          {points.map((point, index) => <motion.div key={index} variants={itemVariants} className="flex flex-col items-center text-center" data-id="element-91">
              <div className="w-12 h-[1px] bg-terracotta mb-8" data-id="element-92" />
              <h3 className="text-2xl text-matte mb-4" data-id="element-93">{point.title}</h3>
              <p className="text-matte/70 leading-relaxed max-w-sm" data-id="element-94">
                {point.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}